'use client';

import dynamic from 'next/dynamic';

export const LazyGoogleMap = dynamic(() => import('./GoogleMap').then((m) => m.GoogleMap), {
  ssr: false,
});
